import { Component, ViewChild, OnInit, OnDestroy, Input, EventEmitter, Output, Injector } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { PermissionSetService, PermissionSetAssigneeTargetService, AssigneeAppletDtoModel } from 'blg-akaun-ts-lib';
import { PermissionFacade } from '../../../../../../modules/permission/facades/permission.facade';
import { gridOptionsServerSide, pageFiltering, pageSorting } from '../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { AppConfig } from '../../../../../../visa';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../permission-controller/root';
import { UserPermSelectors } from '../../../../../../modules/permission/user-permissions-controller/selectors';
import { UserPermActions } from '../../../../../../modules/permission/user-permissions-controller/actions';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-user-permission-set',
    templateUrl: './user-permission-set.component.html',
    styleUrls: ['./user-permission-set.component.scss']
})

export class UserPermissionSetComponent extends ViewColumnComponent implements OnInit, OnDestroy {

    @ViewChild(MatTabGroup, {static:true}) matTab: MatTabGroup;

    @ViewChild(PaginationComponent, {static: false})
    private paginationComponent: PaginationComponent;

    @Input() localState: any;
    @Output() permissionSetEntity = new EventEmitter();
    @Output() toCreatePermissionSet = new EventEmitter();

    // api visa
    apiVisa = AppConfig.apiVisa;

    // initial ag grid state
    gridApi;
    gridOptions = gridOptionsServerSide;
    columnsDefs;
    rowSelection = 'single';

    userGuid: string;

    // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
    private subSink = new SubSink;

    appletGuid = sessionStorage.getItem('appletGuid');
    //translation variable
    create_button: string;
    permission_set_code_text: string;
    permission_set_name_text: string;

    constructor(
        // private fb: FormBuilder,
        private store: Store<PermissionStates>,
        private viewColFacade: PermissionFacade,
        // private readonly componentStore: ComponentStore<{localState: LocalState}>,
        private permissionSetService: PermissionSetService,
        private permissionSetAssigneeTargetService: PermissionSetAssigneeTargetService,
        private injector: Injector
      ) {
        super();
        const translateService = this.injector.get(TranslateService, null);
        if (translateService) {
          translateService.get('labels').subscribe(res => {
            this.permission_set_code_text = res.permission_set_code;
            this.permission_set_name_text = res.permission_set_name;
            this.create_button = res.create_button_nocaps;
          });
        } else {
          // Fallback if translation service is unavailable
          this.permission_set_code_text = 'Permission Set Code';
          this.permission_set_name_text = 'Permission Set Name';
          this.create_button = 'Create';
        }
      }

    /**
     * Lifecycle method: Called when component is first initialised.
     */
    ngOnInit(): void {

        this.columnsDefs = [
            {
                headerName: this.permission_set_code_text,
                field: 'app_perm_set_hdr.code',
                cellStyle: {textAlign: 'left'}
            },
            {
                headerName: this.permission_set_name_text,
                field: 'app_perm_set_hdr.name',
                cellStyle: {textAlign: 'left'}
            }
        ]
    }

    /**
     * This function is called when the user clicks on the Add button in the UI.
     * Will trigger the add component to be shown on the screen.
     *
     */
    onNext() {
      this.toCreatePermissionSet.emit();
    }

    /**
     * This function is called when AG grid is first initialised and initially
     * set the datasource of the grid.
     *
     * @param params : grid parameters
     */
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridApi.closeToolPanel();

        this.subSink.sink = this.store.select(UserPermSelectors.selectSelectedUser).subscribe(user => {
            console.log("user",user);
            if(user) {
                this.userGuid = user.userModel.bl_applet_login_subject_link.app_login_guid.toString();
                console.log("UserGuid: ",this.userGuid);
                const datasource = this.getDatasource();
                this.gridApi.setServerSideDatasource(datasource);
            }
        })

        // refresh AG grid if there has been an update
        this.store.select(UserPermSelectors.selectUpdatePermSetListing).subscribe(x => {
          if (x) {
            if (this.gridApi.getDisplayedRowCount() > 0) {
              this.gridApi.refreshServerSideStore();
            } else {
              this.gridApi.refreshServerSideStore(
                {purge: true}
              )
            }
            this.store.dispatch(UserPermActions.setUpdatePermSetListing({update: false}));
          }
        })
    }

    /**
     * Returns the datasource for the AG grid.
     *
     * @param conditionalCriteria : any custom criteria to search for in the API
     * @returns the datasource
     */
    getDatasource(conditionalCriteria?){
      let offset = 0;
      let limit = this.paginationComponent.rowPerPage;

      return {
          getRows: grid => {

              const sortModel = grid.request.sortModel;
              const filterModel = grid.request.filterModel;
              const sortOn = pageSorting(sortModel);
              const filter = pageFiltering(filterModel);

              // only change offset and limit if no filterModel or sortModel is present
              if (Object.keys(filterModel).length == 0 && sortModel.length == 0) {
                  offset = grid.request.startRow;
                  limit = grid.request.endRow - offset;
              }

              let assigneeAppletDto = new AssigneeAppletDtoModel();
              assigneeAppletDto.assignee_hdr_table = "app_login_subject";
              assigneeAppletDto.assignee_guid = this.userGuid;
              assigneeAppletDto.applet_guid = this.appletGuid;

              this.subSink.sink = this.permissionSetAssigneeTargetService.permissionSetAssigneeTargetAllocation(assigneeAppletDto, this.apiVisa)
              .subscribe(a => {
                  console.log("a.data(PermSet): ", a.data);
                  console.log("a.data[offset](PermSet): ", a.data[offset]);
                  // put data into the grid
                  const data = sortOn(a.data).filter(entity => filter.by(entity));
                  const totalRecords = filter.isFiltering ? a.data.length : data.length;

                  console.log("Data: ",data);
                  console.log("Data[offset]: ",data[offset]);
                  console.log("totalRecords: ",totalRecords);
                  // grid.success({
                  //     rowData: data,
                  //     rowCount: totalRecords,
                  // });
                  grid.successCallback(data, totalRecords)

                  // force pagination to go to first page if filter is applied
                  if (this.paginationComponent.currentPage > this.paginationComponent.totalPage.value) { this.paginationComponent.firstPage() }

                  // this.gridApi.forEachNode(a => {
                  //   console.log("foreachnode a:",a);
                  //   console.log("this.localState", this.localState);
                  //   console.log("this.localState.selectedRow", this.localState.selectedRow);
                  //   if(a.data.generic_doc_hdr_guid === this.localState.selectedRow) {
                  //     a.setSelected(true);
                  //   }
                  // });

                }, err => {
                  // grid.fail();
                  console.log("ERR: ",err);
                  grid.failCallback();
              })
          }
      }

    }

  /**
   * This function is called every time the user clicks on a row in the
   * AG grid.
   *
   * @param entity : the entity on the AG grid that was clicked on
   */
  onRowClicked(entity) {
    this.permissionSetEntity.emit(entity);
  }


  /**
   * Lifecycle method: Called when component is destroyed.
   */
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
